/* MAUD quick view (T, Oct 6 2026).
   Any product link inside [data-qv-scope] opens that product's real product page section
   (Section Rendering API: ?section_id=main) in a pop-up — same gallery, colour arrows,
   Front/Back, size picker and Add to Cart — so shoppers never leave the page.
   The pop-up is one fixed card (no scrolling); the product details box (bullets + size guide)
   opens over it from the PRODUCT DETAILS button (T, Oct 6).
   Falls back to a normal page load if anything fails. */
(function () {
  var cache = {}, box = null, body = null, details = null, open = false, lastFocus = null, reqId = 0;
  var lock = function (on) {
    var L = window.__maudLock;
    if (L) { on ? L.on() : L.off(); return; }
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'mqv';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product');
    box.hidden = true;
    box.innerHTML = '<div class="mqv__veil" data-mqv-close></div>' +
      '<div class="mqv__panel"><button type="button" class="mqv__close" data-mqv-close aria-label="Close"></button>' +
      '<div class="mqv__body"></div>' +
      '<button type="button" class="mqv__details-btn" data-mqv-details hidden>Product details</button>' +
      '<div class="mqv__details" aria-hidden="true"><div class="mqv__details-body"></div>' +
      '<button type="button" class="mqv__details-back" data-mqv-back>Back</button>' +
      '<a class="mqv__full" href="#">View full details</a></div></div>';
    document.body.appendChild(box);
    body = box.querySelector('.mqv__body');
    details = box.querySelector('.mqv__details-body');
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-mqv-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-mqv-details]')) { e.preventDefault(); showDetails(true); return; }
      if (e.target.closest('[data-mqv-back]')) { e.preventDefault(); showDetails(false); }
    });
  }

  function showDetails(on) {
    box.classList.toggle('is-details', !!on);
    box.querySelector('.mqv__details').setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  /* the whole product page is fetched (its main section id differs per template/theme) and only the product block is kept */
  function sectionUrl(href) {
    var u = new URL(href, location.origin);
    return u.pathname + u.search;
  }

  function load(href) {
    var key = sectionUrl(href);
    if (!cache[key]) {
      cache[key] = fetch(key, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).catch(function (e) { delete cache[key]; throw e; });
    }
    return cache[key];
  }

  /* innerHTML never runs <script>s — recreate them so inline helpers work */
  function runScripts(el) {
    el.querySelectorAll('script').forEach(function (old) {
      if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;
      var s = document.createElement('script');
      [].forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function show(href) {
    build();
    var my = ++reqId;
    lastFocus = document.activeElement;
    box.querySelector('.mqv__full').href = href;
    showDetails(false);
    details.innerHTML = '';
    box.querySelector('.mqv__details-btn').hidden = true;
    body.innerHTML = '<div class="mqv__loading" aria-live="polite"><span></span>Loading</div>';
    box.hidden = false;
    if (!open) { lock(true); open = true; }
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    load(href).then(function (html) {
      if (my !== reqId || !open) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* DOMParser runs with scripting off, so <noscript> fallbacks (e.g. the no-JS variant <select name="id">) come through as real
         elements and break the variant picker — drop them */
      doc.querySelectorAll('noscript').forEach(function (n) { n.remove(); });
      /* picking a colour/size in the pop-up must not rewrite the home page URL */
      doc.querySelectorAll('[update-url]').forEach(function (n) { n.removeAttribute('update-url'); });
      var sec = doc.querySelector('[id^="shopify-section-"][id$="__main"]');
      /* only the product (not the shared drawers/popovers the section also prints) */
      var prod = sec && sec.querySelector('.product');
      if (!prod) throw new Error('no product');
      prod = document.importNode(prod, true);
      var wrap = document.createElement('div');
      wrap.className = 'mqv__product';
      wrap.appendChild(prod);
      /* product details box (bullets + size guide) lives behind the PRODUCT DETAILS button */
      var card = wrap.querySelector('.dtg-info__card');
      if (card) {
        details.appendChild(card);
        box.querySelector('.mqv__details-btn').hidden = false;
      }
      body.innerHTML = '';
      body.appendChild(wrap);
      runScripts(wrap);
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (e) {} }
      var c = box.querySelector('.mqv__close'); if (c) c.focus({ preventScroll: true });
    }).catch(function () { location.href = href; });
  }

  function close() {
    if (!open) return;
    open = false; reqId++;
    box.classList.remove('is-open');
    setTimeout(function () { if (!open) { box.hidden = true; body.innerHTML = ''; details.innerHTML = ''; showDetails(false); } }, 260);
    lock(false);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* capture on window so the theme's page-transition link handler never sees the click */
  window.addEventListener('click', function (e) {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('[data-qv-scope] a[href*="/products/"]');
    if (!a || (box && box.contains(a))) return;
    var card = a.closest('maud-dtg-card') || (a.querySelector && a.querySelector('maud-dtg-card'));
    if (card && card._swiped && Date.now() - card._swiped < 500) return;   /* a swipe on the card, not a tap */
    e.preventDefault();
    e.stopPropagation();
    show(a.href);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !open) return;
    if (box.classList.contains('is-details')) showDetails(false); else close();
  });
  /* added to cart → close so the cart drawer has the stage */
  document.addEventListener('variant:added', function () { if (open) setTimeout(close, 150); });
  /* warm the first tees once the page is idle so the pop-up opens instantly */
  addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('[data-qv-scope] a.dtg-card__link').forEach(function (a, i) {
        if (i < 4) load(a.href).catch(function () {});
      });
    }, 2500);
  });
})();
